// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'right',
		//suggestionWidth: 'auto'
		suggestionMobileStyle: 'style2'
	}
};

(function () {
BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {};

	jQ('.js-search-trigger').on('click', function() {
		jQ('body').addClass('boost-pfs-custom-open-search-mobile');
	});
  
  	
    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the params before calling api */
      	// console.log(searchTerm);
        // Globals.instantSearchQueryParams = ...;
    }
 
    SearchInput.prototype._onSubmit = function(event, redirect) {
		//if (isDisabledInstantSearch) return;

		if (typeof redirect == 'undefined') {
			redirect = this.isChangePage;
		}
		this.isChangePage = false;

		if (!redirect) {
			// Stop all default submit events
			event.stopImmediatePropagation();
			event.stopPropagation();
			event.preventDefault();
          
			// Fix case can not get current value from input
			Globals.currentTerm = Utils.stripHtml(this.$element.val());
			if (!Globals.currentTerm && event && event.target) {
				Globals.searchTerm = Utils.stripHtml(event.target.value);
			}
			var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();

			// if API returned results or the suggestionCache has the search term, submit search
			// else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
			// then remove this attribute in the checkForSearchRedirect function
			var query = Globals.currentTerm;
			var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
			// Set recent searches
			// InstantSearchOnclick.setOnClickRecentSearches(query);
          
          	if(typeof(boostPFSThemeConfig) !== 'undefined'){
            var customer_id = boostPFSThemeConfig.custom.customer.id
            var customer_type = customer_id != '' ? 'registered_user' : 'guest'
                          
            window.dataLayer.push({
                event: 'search',
                  customerID: customer_id,
                  customer_type: customer_type,
                  search_term: query
              });

            }
			// If the API returned results, either redirect or perform submit
			if (isApiReturnedResult) {
				if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
					Utils.setWindowLocation(redirectUrl);
				} else {
					this.isChangePage = true;
					this.$searchForm[0].submit();
				}
			} else if (Globals.currentTerm) {
				// If the API hasn't returned results, set data-search-submit on the search input and wait
				this.$element.data('search-submit', true);
			} else {
				this.isChangePage = true;
				this.$searchForm[0].submit();
			}
		}
	}

})();  